import React, { useEffect } from "react";
import {
  clearClaimInvestmentSuccess,
  getUserInvestmentsRequest,
} from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { CircularProgress } from "@material-ui/core";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { AdminInvestmentCard } from "../../../components/Cards/AdminInvestmentCard";
import {
  AdminSideNav,
  AuthNav,
  SideNav,
} from "../../../components/Navbar/Webpages/AuthNav";
import { BriefcaseIcon, ArrowLeftIcon } from "@heroicons/react/outline";

const UserInvestments = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    getUserInvestmentsError,
    investments,
    getUserInvestmentsLoading,
    claimInvestmentSuccess,
    claimInvestmentError,
    claimInvestmentLoading,
    token,
  } = useSelector((state) => {
    const {
      success: { claimInvestment: claimInvestmentSuccess },
      errors: {
        getUserInvestments: getUserInvestmentsError,
        claimInvestment: claimInvestmentError,
      },
    } = state.ajaxStatuses;

    const { getUserInvestmentsLoading, claimInvestmentLoading } =
      state.loadingIndicator;

    const { token } = state.userData;
    const { investments } = state.investmentData;

    return {
      getUserInvestmentsError,
      investments,
      getUserInvestmentsLoading,
      claimInvestmentSuccess,
      claimInvestmentError,
      claimInvestmentLoading,
      token,
    };
  });

  useEffect(() => {
    dispatch(getUserInvestmentsRequest(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (getUserInvestmentsError) toast.error(getUserInvestmentsError);
    if (claimInvestmentError) toast.error(claimInvestmentError);
    if (claimInvestmentSuccess) {
      toast.success(claimInvestmentSuccess);
      dispatch(clearClaimInvestmentSuccess());
    }
  }, [
    getUserInvestmentsError,
    claimInvestmentError,
    claimInvestmentSuccess,
    dispatch,
  ]);

  return (
    <div className="bg-gray-50 min-h-screen">
      <AuthNav />
      {/* Assuming SideNav is fixed or handles its own layout, 
          adding padding-left if SideNav is persistent on desktop could be needed */}
      <AdminSideNav />

      <div className="container max-w-3xl mx-auto px-4 py-8 mb-20 pt-24">
        {/* Header with Back Button */}
        <div className="flex items-center gap-4 mb-8">
          <Link
            to="/admin/dashboard"
            className="p-2 bg-white rounded-full shadow-sm text-gray-500 hover:text-primary transition-colors"
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </Link>
          <div>
            <h1 className="text-2xl font-heading font-bold text-gray-900">
              User Investments
            </h1>
            <p className="text-sm text-gray-500 font-body">
              Manage active and past plans for this user
            </p>
          </div>
        </div>

        {getUserInvestmentsLoading ? (
          <div className="flex flex-col items-center justify-center py-32">
            <CircularProgress size={40} style={{ color: "#4F46E5" }} />
            <p className="mt-4 text-gray-500 font-medium">
              Loading investments...
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {investments.length === 0 ? (
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 text-center">
                <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-400">
                  <BriefcaseIcon className="w-8 h-8" />
                </div>
                <h3 className="text-lg font-heading font-bold text-gray-900">
                  No Investments Found
                </h3>
                <p className="text-gray-500 mt-2">
                  This user has not purchased any investment plans yet.
                </p>
              </div>
            ) : (
              investments.map((data, index) => (
                <AdminInvestmentCard
                  key={index}
                  data={data}
                  loading={claimInvestmentLoading}
                  token={token}
                  getUserInvestmentsRequest={getUserInvestmentsRequest}
                />
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserInvestments;
